<template>
  <div
    :key="props.notification.id"
    class="ui-notification"
    :data-status=computedStatus.toLocaleLowerCase()
    @click="disolveNotification(notification)"
    @mouseover="dataIsDisolvePaused = true"
    @mouseleave="dataIsDisolvePaused = false"
    >
    <div
      class="mb-2"
      v-html="props.notification.text"
      />

    <div v-if="props.notification.errors" class="my-4">
      <ul
        v-for="(err, key) in props.notification.errors"
        :key="'msg_'+key"
        class="list-disc pb-1 pl-6 !list-outside"
        >
        <li
          v-for="(msg, k) in err"
          :key="'msg_sub_'+k"
          >
          <span v-text="msg" />
        </li>
      </ul>
    </div>

    <div v-if="props.notification.button && props.notification.buttonaction" class="my-2 flex justify-center">
      <ui-button
        class="dark icon w-full"
        :text="props.notification.button"
        @click="props.notification.buttonaction"
        />
    </div>

    <span v-if="notification.timeout" class="absolute text-[10px] bottom-1 left-0 right-0 flex">
      <ui-progress-circle
        v-model:paused="dataIsDisolvePaused"
        model-value="100"
        :duration="notification.timeout"
        width="12"
        class="w-[3px] m-auto"
        class-stroke="!text-white"
        class-background="!text-transparent"
        @full="disolveNotification(notification)"
        />
    </span>

    <span
      class="absolute text-[10px] bottom-0 left-4"
      v-text="computedStatus"
      />
    <span
      class="absolute text-[10px] bottom-0 right-4"
      v-text="t('Click to dismiss')"
      />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
	notification: AppNotification,
}>()

const dataIsDisolvePaused = ref(!props.notification.timeout ? true : false)

const { t } = useI18n({
  messages: {
    en: {
      'Click to dismiss': 'Click to dismiss',
    },
    de: {
      'Click to dismiss': 'Zum Schließen anklicken',
    },
    es: {
      'Click to dismiss': 'Haga clic para cerrar',
    },
    uk: {
      'Click to dismiss': 'Натисніть, щоб закрити',
    },
  } as any
})

const computedStatus = computed(() => {
  let r = props.notification?.type ?? 'success'

  r = r.charAt(0).toUpperCase() + r.slice(1)

  return r
})

watch(() => props.notification.timeout, (val) => {
  if(val){
    dataIsDisolvePaused.value = false
  }
})
</script>
